import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import "../App.css";

const percepcionesDisponibles = [
    "Ret IIBB San Juan",
    "Ret IIBB CABA",
    "Perc IIBB Catamarca",
    "Perc IIBB Mendoza",
    "Ret RG830 Locación de Obra y Servicios",
    "Perc IIBB Neuquen",
    "Perc IIBB CABA Reg General",
    "IMPUESTOS INTERNOS",
    "Ret IIBB Santa Cruz",
    "Perc IVA 3%",
    "Ret RG SSUS 1784",
    "Ret RG830 Alquileres o arrendamientos de Bs Mueble",
    "Ret Alquileres o arrendamientos de inm en el país",
    "Perc IIBB Tucuman",
    "Ret RG830 Operac transpte de carga nacional e inte",
    "Ret Fondo Minero",
    "Ret IIBB Rio Negro",
    "Perc IIBB Buenos Aires sufridas",
    "Ret IIBB Tierra del Fuego",
    "Ret IIBB Chubut",
    "Ret IIBB Jujuy",
    "Ret IIBB Mendoza",
    "Ret IIBB Misiones",
    "Ret IIBB Neuquen",
    "Ret IIBB Buenos Aires",
    "Ret IIBB Salta",
    "Perc IIBB Corrientes",
    "Ret IIBB San Luis",
    "Perc SIRCREB IIBB",
    "Ret IIBB Catamarca",
    "Ret IIBB Tucuman",
    "Ret Fondo de Reparo",
    "Ret IVA Regimen Factura M",
    "Ret RG830 Locación de Obra y Servicios",
    "Ret Gan Regimen de Factura M 6%",
    "Ret RG SSUS 1784",
    "Ret Lote Hogar",
    "Ret RG SSUS Ingenieria",
    "Ret RG830 Enajenación de Bs Muebles y Bs de Cambio",
    "Ret IVA RG AFIP 2854 21%",
    "IMPUESTO PAIS",
    "PERC LOTE HOGAR",
    "Perc Ganancias",
    "Perc IIBB San Juan",
    "Ret Municipalidad de Tolar Grande",

];

const Percepciones = () => {
  const navigate = useNavigate();

  const [percepciones, setPercepciones] = useState([]);
  const [errores, setErrores] = useState([]);
  const [, setFormTouched] = useState(false); // formTouched, 
  const [showModal, setShowModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(null);

  const agregarPercepcion = () => {
    setPercepciones([...percepciones, { tipo: "", monto: "" }]);
    setFormTouched(true);
  };

  const handleChange = (index, campo, valor) => {
    const nuevasPercepciones = [...percepciones];
    nuevasPercepciones[index][campo] = valor;
    setPercepciones(nuevasPercepciones);
    setFormTouched(true);
  };

  const validar = () => {
    const nuevosErrores = percepciones.map(percep => ({
      tipo: !percep.tipo,
      monto: !percep.monto || isNaN(percep.monto)
    }));
    setErrores(nuevosErrores);
    return nuevosErrores.every(err => !err.tipo && !err.monto);
  };

  const handleNext = async () => {
    if (!validar()) {
      alert("❗ Por favor completá todos los campos correctamente.");
      return;
    }
  
    try {
      const tipoComprobanteData = JSON.parse(localStorage.getItem("tipoComprobante"));
      const tipoDocumento = tipoComprobanteData?.tipoDocumento || null;
      const comprobante = tipoComprobanteData?.comprobante || "";
  
      const res = await fetch("/api/savePercepciones", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          percepciones,
          tipoDocumento,
          tipoComprobante: {
            comprobante: comprobante,
          },
        }),
      });
  
      const result = await res.json();
      const nextInvoiceNumber = result.invoiceNumber;
  
      if (nextInvoiceNumber) {
        localStorage.setItem("nextInvoiceNumber", nextInvoiceNumber); // ✅ ahora se guarda correctamente
        localStorage.setItem("tipoDocumento", tipoDocumento); // ✅ AGREGAR ESTA LÍNEA
      } else {
        console.warn("⚠️ No se recibió invoiceNumber del backend.");
      }
  
      navigate("/header");
    } catch (error) {
      console.error("❌ Error al guardar percepciones:", error);
      alert("❌ Error de conexión al servidor");
    }
  };
  
  
  const handleBack = () => {
    const hayPercepciones = percepciones.length > 0;
    const algunaPercepcionCompletada = percepciones.some(
      percep => percep.tipo !== "" || percep.monto !== ""
    );

    if (hayPercepciones && algunaPercepcionCompletada) {
      setShowModal(true);
    } else {
      navigate("/tipo-comprobante");
    }
  };

  const confirmarVolver = () => {
    setShowModal(false);
    navigate("/tipo-comprobante");
  };

  const eliminarPercepcion = (index) => {
    const nuevasPercepciones = percepciones.filter((_, idx) => idx !== index);
    setPercepciones(nuevasPercepciones);
    setFormTouched(true);
  };

  const handleDelete = (index) => {
    setIndexToDelete(index);
    setShowConfirmModal(true);
  };

  return (
    <div className="percepciones-container">
      <div className="header">
        <h3>Percepciones</h3>
        <div className="nuevo-btn-container">
          <button className="primary-button" onClick={agregarPercepcion}>
            Nueva Percepción
          </button>
        </div>
      </div>

      {percepciones.length === 0 && (
        <>
          <p style={{ textAlign: "center", marginTop: "10px", color: "#555" }}>
            No hay percepciones agregadas. Presiona "Nueva Percepción" para comenzar.
          </p>
          <p style={{ textAlign: "center", marginTop: "10px", color: "#555" }}>
            Si no tiene percepciones a cargar, presione "Siguiente" para avanzar.
          </p>
        </>
      )}

      <div className="percepciones-form">
        {percepciones.map((percep, index) => (
          <div key={index} className="percepcion-row">
            <select
              className={`percep-input-field ${errores[index]?.tipo ? "error" : ""}`}
              value={percep.tipo}
              onChange={(e) => handleChange(index, "tipo", e.target.value)}
            >
              <option value="">Seleccione Percepción</option>
              {percepcionesDisponibles.map((p, idx) => (
                <option key={idx} value={p}>
                  {p}
                </option>
              ))}
            </select>
            <input
              type="number"
              className={`percep-input-field ${errores[index]?.monto ? "error" : ""}`}
              placeholder="Monto"
              value={percep.monto}
              onChange={(e) => handleChange(index, "monto", e.target.value)}
            />
            <button
              type="button"
              className="delete-button"
              onClick={() => handleDelete(index)}
            >
              <FaTrashAlt />
            </button>
          </div>
        ))}
      </div>

      <div className="button-container">
        <button className="secondary-button" onClick={handleBack}>
          Atrás
        </button>
        <button className="primary-button" onClick={handleNext}>
          Siguiente
        </button>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">⚠️</div>
            <p>¿Deseás volver? Se perderán los datos ingresados.</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={confirmarVolver}>Sí, volver</button>
              <button className="no-btn" onClick={() => setShowModal(false)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {showConfirmModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-popup">
            <div className="warning-icon">⚠️</div>
            <p>¿Estás seguro que deseas eliminar esta percepción?</p>
            <div className="modal-buttons">
              <button className="yes-btn" onClick={() => {
                  eliminarPercepcion(indexToDelete);
                  setShowConfirmModal(false);
                  setIndexToDelete(null);
                }}>Sí</button>
              <button className="no-btn" onClick={() => {
                  setShowConfirmModal(false);
                  setIndexToDelete(null);
                }}>No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Percepciones;


